var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3511C0 4.82823 4.47715 0.351074 10 0.351074C15.5228 0.351074 20 4.82823 20 10.3511C20 15.8739 15.5228 20.3511 10 20.3511C4.47715 20.3511 0 15.8739 0 10.3511Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.3511C14.3284 10.3511 15 11.0226 15 11.8511V12.3511C15 14.3225 13.1405 16.3511 10 16.3511C6.85951 16.3511 5 14.3225 5 12.3511V11.8511C5 11.0226 5.67157 10.3511 6.5 10.3511H13.5ZM13.5 11.3511H6.5C6.22386 11.3511 6 11.5749 6 11.8511V12.3511C6 13.7887 7.43216 15.3511 10 15.3511C12.5678 15.3511 14 13.7887 14 12.3511V11.8511C14 11.5749 13.7761 11.3511 13.5 11.3511ZM10 3.85107C11.5188 3.85107 12.75 5.08229 12.75 6.60107C12.75 8.11986 11.5188 9.35107 10 9.35107C8.48122 9.35107 7.25 8.11986 7.25 6.60107C7.25 5.08229 8.48122 3.85107 10 3.85107ZM10 4.85107C9.0335 4.85107 8.25 5.63458 8.25 6.60107C8.25 7.56757 9.0335 8.35107 10 8.35107C10.9665 8.35107 11.75 7.56757 11.75 6.60107C11.75 5.63458 10.9665 4.85107 10 4.85107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.7403b57d21acf8914ca780266783b8c0.svg";
export { ForwardRef as ReactComponent };